import { render } from "./EditAttendee.vue?vue&type=template&id=49dcd2e2&scoped=true"
import script from "./EditAttendee.vue?vue&type=script&lang=js"
export * from "./EditAttendee.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-49dcd2e2"

export default script